/**
 Created by qing on 2020/5/25
 Des: 自定义图表
 */
import BaseChart from "../BaseChart"
import {
  CHART_CATEGORY__CONTAINER,
  CHART_TYPE__CONTAINER_CHART
} from "../types"

class CustomChart extends BaseChart {
  constructor() {
    super()

    this.h = 6

    this.minW = 8
    this.minH = 2

    this.showPropertiesHolder = {
      showType: '',
      dataType: 'FIXED',  // FIELD 表单字段 FIXED 固定值
      relateConfig: {
        appId: '',
        formId: '',
        fieldId: '',
        filterInfo: {
          relation: "and",
          notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: []
        },
        advancedFilter: 0,
        tableFieldId: '',
        advancedFilterInfo: {
          relation: "and",
          notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: []
        }
      },
      showValue: '',
      fontSize: '18px',
      background: {
        type: "color",
        color: "",
        image: "",
        position: "center"
      }, // 背景
      titleColor: "", // 组件整体标题颜色
      contentColor: '',
      textAlign: 'center', // 文字布局

      // 时间组件
      dateFormatter: 'yyyy-MM-dd',

      // 图片组件
      imageSrc: '',
      imageSrcList: [],
      imageToUrl: '',
      imageStyle: 'contain', // 图片布局 fill 拉伸填满, contain 居中填满,  cover 自适应
      jumpType: '_self', // 跳转方式， _self 当前页面打开 ， _blank 新页面打开

    }

    this.chartPropertiesHolder = {
    }

  }

  get title() {
    return this.chartName || CustomChart._title
  }

  set title(content) {
    this.chartName = content
  }

}

CustomChart._title = ''
CustomChart.type = CHART_TYPE__CONTAINER_CHART

CustomChart.prototype.chartCategory = CHART_CATEGORY__CONTAINER
CustomChart.prototype.chartType = CustomChart.type
CustomChart.prototype.getValue = function () {
}

export default CustomChart
